module.exports = __webpack_public_path__ + "img/lands.6a5fa00f.png";